import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { isAuthenticated, logout, updateEmail, confirmEmail, forgotPassword, confirmForgotPassword, getUserAccount } from '../../services/self'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import { Button, Form, Message } from 'semantic-ui-react'
import logo from '../../Nlogo.png'

export default class CaseStudies extends PureComponent{

  state = {
    isSubmitting: false,
    signedIn: false,
    errorMessage: '',
    isOpen: false,
    success: false,
    updateEmailSuccess: false,
    confirmEmailSuccess: false,
    resetCodeSentSuccess: false,
    changedPasswordSuccess: false,
    newemail: '',
    emailCode: '',
    confirmusername: '',
    verificationcode: '',
    password: '',
    username: ''

  }

  updateEmail = (event, serializedForm) => {
    event.preventDefault()
    //var newEmail = serializedForm.email;
    updateEmail(this.state.newemail)
    this.setState({updateEmailSuccess: true});
  }

  confirmEmail = (event, serializedForm) => {
    event.preventDefault()
    //var code = serializedForm.code;
    confirmEmail(this.state.emailCode)
    this.setState({confirmEmailSuccess: true});
  }

  _forgotPassword = (event, serializedForm) => {
    event.preventDefault();
    //var username = serializedForm.username;
    forgotPassword(this.state.username);
    this.setState({resetCodeSentSuccess: true})
    console.log(`Reset Code Sent Success state: ${this.state.resetCodeSentSuccess}`)
  }


  _getUserAccount = () => {
    var name;
    name = getUserAccount();
    return name;
  }


  confirmForgotPassword(event, serializedForm){
    event.preventDefault()
    var username = this.state.confirmusername;
    var verificationCode = this.state.verificationcode;
    var newPassword = this.state.password;
    confirmForgotPassword(username, verificationCode, newPassword)
    this.setState({changedPasswordSuccess: true})

  }



  logout() {
    logout()
    this.setState({ loggedOut: true })
  }



render() {


  return(

  <div>

      <div className="Logo">
        <Link className="home-link2" to='/'><img src={logo} className="App-logo" alt="logo" /></Link>
        <Link className="home-link" to='/'>Developer</Link>
      </div>

      <div className="Navbar-Div">
        <nav className="App-navbar">
        <Link className="Centered-link" to='/updates'>Updates</Link>
        <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
        <Link className="Centered-link" to='/documentation'>Docs</Link>
        <Link className="Centered-link" to='/tools'>Tools</Link>
        <Link className="Centered-link" to='/community'>Community</Link>

        <div className="right">
          {isAuthenticated() ? (<Link to='/account'>Account</Link>) : ''}
          {isAuthenticated() ? (<Link to='' onClick={() => this.logout()}>Log out</Link>) : ''}
        </div>

            {isAuthenticated() ? '' : (
              <span className="right">
                <SignIn className="right" />
                <Register className="right-link" />
              </span>
            )}
        </nav>
      </div>

      <div className="App-banner">

        <span className="orange-bold"> NEWFORMA </span> Your partner for all things AECO project information management. <a className="newforma-world-link" href="https://www.newforma.com/">Learn More</a>
      </div>
      <div className="main-content">
        <div className="account-welcome"> Welcome <span className="orange">{this._getUserAccount()} </span></div>
        <div className="account-header"><p className="account-header-text">BASICS</p></div>
        <div className="update-account-info">
          <p className="update-email-info">To update your email address please submit desired new email address in the "Update Email" box below. After submitting you will receive
          a confirmation email with a verification code. Please confirm your new email by entering your confirmation code below.</p>

        <div className="update-email-form">
        <Form success={this.state.updateEmailSuccess} onSubmit={this.updateEmail} error={!!this.state.errorMessage} loading={this.state.isSubmitting}>
          <Form.Input label='Update Email' placeholder='user@domain.com' name='email' onChange={ (e) => this.setState({ newemail: e.target.value }) } />
          <Message error content={this.state.errorMessage} />
          <Message success header='Submitted' content={this.state.updateEmailSuccess ? 'If you have a registered account we have emailed you a confirmation code' : ''} />

          <Button primary type='submit' style={{background: '#003C4D'}}>Change Email Address</Button>
        </Form>
        </div>

        <div className="confirm-new-email-form">

          <Form success={this.state.updateEmailSuccess} onSubmit={this.confirmEmail} error={!!this.state.errorMessage} loading={this.state.isSubmitting}>
            <Form.Input label='Verification Code' placeholder='enter code here #####' name='code' onChange={ (e) => this.setState({ emailCode: e.target.value }) }/>
            <Message error content={this.state.errorMessage} />
            <Message success header='Email Confirmed' content={this.state.updateEmailSuccess ? 'You have successfully confirmed your new email address.' : ''} />
            <Button primary type='submit' style={{background: '#003C4D'}}>Confirm New Email</Button>
          </Form>

        </div>
        <div className="moreSpace"></div>

        <p className="update-email-info">To change your password please enter you username below to receive a change password code.</p>
        <div>
          <Form success={this.state.resetCodeSentSuccess} onSubmit={this._forgotPassword} error={!!this.state.errorMessage} loading={this.state.isSubmitting}>
            <Form.Input label='Username' name='username' placeholder='Username' onChange={ (e) => this.setState({ username: e.target.value }) }/>
            <Message success header='Reset Code Sent' content={this.state.resetCodeSentSuccess ? 'Please check your email for a reset code.' : ''} />
            <Button primary type='submit' style={{background: '#003C4D'}}>Get Reset Password Code</Button>
          </Form>
        </div>

        <div className="moreSpace"></div>

        <p className="update-email-info">Enter code and new password below to update your password.</p>
        <div>
          <Form success={this.state.changedPasswordSuccess} onSubmit={this.confirmForgotPassword} error={!!this.state.errorMessage} loading={this.state.isSubmitting}>
            <Form.Input label='Username' name='usernameReset' placeholder='Username' onChange={ (e) => this.setState({ confirmusername: e.target.value }) }/>
            <Form.Input label='Verification Code' name='verificationCode' placeholder='Verification Code' onChange={ (e) => this.setState({ verificationcode: e.target.value }) }/>
            <Form.Input type='password' label='New Password' name='newPassword' placeholder='New Password' onChange={ (e) => this.setState({ password: e.target.value }) }/>
            <Message error content={this.state.errorMessage} />
            <Message success header='Reset Code Sent' content={this.state.changedPasswordSuccess ? 'Please check your email for a reset code.' : ''} />
            <Button primary type='submit' style={{background: '#003C4D'}}>Change Password</Button>
          </Form>
        </div>
        <div className="moreSpace"></div>

        </div>


      </div>

    </div> )


  }

}



/** WEBPACK FOOTER **
 ** ./src/pages/Account/index.js
 **/